module.exports = __webpack_public_path__ + "img/mv06.a9cc19e3.png";